<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field    
        outlined
        dense
        readonly
        :label="lable"
        v-on="on"      
        :value="setectVale"
      ></v-text-field>
    </template>
    <v-date-picker            
      @change="save"
    ></v-date-picker>
  </v-menu>
</template>

<script>
  export default {
      props: ["setectVale", "lable"],
    data: () => ({  
      menu: false,
    }),
    
    methods: {
      save (date) {      
        this.$emit("changeInput", date);    
        this.menu = false
      }      
    },
  }
</script>